"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("@/helpers");
var _components = require("@/components");
var _validators = require("vuelidate/lib/validators");
var _vuex = require("vuex");
var _auth = require("@/utils/auth");
var _vue2Editor = require("vue2-editor");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  components: {
    Card: _components.Card,
    VueEditor: _vue2Editor.VueEditor
  },
  props: {
    showWarning: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      idAsset: null,
      idService: null,
      title: null,
      arquivo: null,
      descricao: null,
      link: null,
      formAsset: {}
    };
  },
  watch: {
    arquivo: function () {
      var _arquivo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(val && val.type)) {
                _context.n = 1;
                break;
              }
              if (!(val.type.indexOf('image/') <= -1)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, _helpers.messageHelper.error('Somente arquivos de imagens são aceitos'));
            case 1:
              this.arquivo = val;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function arquivo(_x) {
        return _arquivo.apply(this, arguments);
      }
      return arquivo;
    }()
  },
  created: function created() {
    var id = this.$route.params.id;
    if (id) {
      this.idService = id;
      this.getDetails();
    }
  },
  validations: function validations() {
    return {
      descricao: {
        required: _validators.required
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['createDescription', 'updateDescription', 'fetchDescription', 'deleteDescription', 'fetchDetailService'])), {}, {
    getDetails: function () {
      var _getDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, dataDocumentantion;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.idService) {
                _context2.n = 3;
                break;
              }
              _context2.n = 1;
              return this.fetchDetailService(this.idService);
            case 1:
              data = _context2.v;
              if (data) {
                this.title = data.name;
              }
              _context2.n = 2;
              return this.fetchDescription(this.idService);
            case 2:
              dataDocumentantion = _context2.v;
              if (Object.keys(dataDocumentantion.data).length > 0) {
                this.formAsset = dataDocumentantion.data;
                this.title = this.formAsset.title;
                this.descricao = this.formAsset.description;
                this.link = this.formAsset.image;
                this.idAsset = this.formAsset.id;
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    checkForm: function () {
      var _checkForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
        var _dataUser$user, _dataUser$user2, payload, operation, message, resp, dataUser, _dataUser$user3, _dataUser$user4, _dataUser$user5, _dataUser$user6;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              e.preventDefault();
              this.$v.$touch();
              if (!this.$v.$invalid) {
                _context3.n = 1;
                break;
              }
              this.$buefy.toast.open({
                duration: 5000,
                message: "A descri\xE7\xE3o do servi\xE7o e de preenchimento obrigat\xF3rio!",
                position: 'is-top',
                type: 'is-danger'
              });
              _context3.n = 6;
              break;
            case 1:
              payload = {};
              operation = this.updateDescription;
              message = 'Alteração realizada com sucesso!';
              resp = null;
              dataUser = (0, _auth.getUser)();
              this.$gtag.config({
                'user_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user = dataUser.user) === null || _dataUser$user === void 0 ? void 0 : _dataUser$user._id,
                'user_name': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user2 = dataUser.user) === null || _dataUser$user2 === void 0 ? void 0 : _dataUser$user2.name
              });
              if (!(Object.keys(this.formAsset).length > 0)) {
                _context3.n = 3;
                break;
              }
              if (this.arquivo) {
                payload = {
                  description: this.descricao,
                  image: this.arquivo
                };
              } else {
                payload = {
                  description: this.descricao
                };
              }
              _context3.n = 2;
              return operation({
                payload: payload,
                assetPlanId: this.idAsset
              });
            case 2:
              resp = _context3.v;
              this.$gtag.event('update_description_documentation', {
                'event_category': 'service',
                'event_label': 'alterar descrição',
                'value': {
                  'user_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user3 = dataUser.user) === null || _dataUser$user3 === void 0 ? void 0 : _dataUser$user3._id,
                  'user_name': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user4 = dataUser.user) === null || _dataUser$user4 === void 0 ? void 0 : _dataUser$user4.name
                }
              });
              _context3.n = 5;
              break;
            case 3:
              payload = {
                digitalAsset: this.idService,
                title: this.title,
                description: this.descricao,
                image: this.arquivo
              };
              operation = this.createDescription;
              message = 'Operação realizada com sucesso!';
              _context3.n = 4;
              return operation(payload);
            case 4:
              resp = _context3.v;
              this.$gtag.event('create_description_documentation', {
                'event_category': 'service',
                'event_label': 'criar descrição',
                'value': {
                  'user_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user5 = dataUser.user) === null || _dataUser$user5 === void 0 ? void 0 : _dataUser$user5._id,
                  'user_name': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user6 = dataUser.user) === null || _dataUser$user6 === void 0 ? void 0 : _dataUser$user6.name
                }
              });
            case 5:
              this.getDetails();
              if (resp) {
                this.$buefy.toast.open({
                  message: message,
                  type: 'is-success',
                  duration: 5000
                });
                this.$emit('update:showWarning', true);
              }
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function checkForm(_x2) {
        return _checkForm.apply(this, arguments);
      }
      return checkForm;
    }()
  })
};